import React, { useEffect, useState } from 'react';
import { IUser } from '../../models';
import { ISchemaType } from '../../models/Schema.model';
import { Spinner2 } from '../shared/spinner2';
import PaneHeadline from '../shared/paneHeadline';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import SurveyTypesGrid from './SurveyTypesGrid';
import SurveyTypeDialog from './SurveyTypeDialog';
import { getCustomerIdInUse } from '../../utils/GeneralUtils';
import SurveyService from '../../services/surveyService';
import { Toastr } from '../../utils/Toastr';
import { AsyncAction } from '../../utils';

import './surveyTypes.scss';
import { locale } from '../../common/localization/localizationService';

export interface ISurveyTypesPageProps {
  impersonatedUser: any;
  authentication: IUser;
  isLoading: boolean;
  schemaTypes: Array<ISchemaType>;
  loadSchemaTypes: (ignoreCache?: boolean) => AsyncAction;
}

export default function SurveyTypesPage(
  props: ISurveyTypesPageProps
): JSX.Element {
  const [isDialogShow, setDialogShow] = useState<boolean>(false);
  const [isDeleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [selectedSurveyType, setSelectedSurveyType] =
    useState<ISchemaType>(null);

  useEffect(() => {
    props.loadSchemaTypes();
  }, []);

  const openSurveyTypeDialog = (surveyType: ISchemaType): void => {
    setSelectedSurveyType(surveyType);
    setDialogShow(true);
  };

  const hideSurveyTypeDialog = (rerender: boolean): void => {
    setDialogShow(false);
    setSelectedSurveyType(null);
    props.loadSchemaTypes(rerender);
  };

  const deleteSurveyType = async (surveyType: ISchemaType): Promise<void> => {
    if (confirm(locale.surveyTypesPage._deleteConfirm + surveyType.name)) {
      try {
        setDeleteLoading(true);
        await SurveyService.deleteSchemaType(surveyType);
        Toastr.success(locale.surveyTypesPage._deleteSuccess);
      } catch (error) {
        Toastr.error(error);
      } finally {
        setDeleteLoading(false);
        props.loadSchemaTypes(true);
      }
    }
  };

  return (
    <div className="survey-types-page">
      <Spinner2 show={props.isLoading || isDeleteLoading} />
      <div className="row">
        <PaneHeadline
          titleText={locale.surveyTypesPage._schemaTypes}
          titleIcon={faCheckDouble}
          className="col-sm-6"
        />
        <div className="col-sm-6 text-right mb-3">
          <button
            className="btn btn-outline-dark"
            onClick={() => openSurveyTypeDialog(null)}
          >
            {locale.surveyTypesPage._addNew}
          </button>
        </div>
      </div>
      <div className="survey-types-wrapper">
        <SurveyTypesGrid
          data={props.schemaTypes}
          deleteSurveyType={deleteSurveyType}
          editSurveyType={openSurveyTypeDialog}
        />
      </div>
      {isDialogShow && (
        <SurveyTypeDialog
          customerId={getCustomerIdInUse(props.authentication)}
          show={isDialogShow}
          surveyType={selectedSurveyType}
          onHide={hideSurveyTypeDialog.bind(this)}
        />
      )}
    </div>
  );
}
